import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/portfolioData";
import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-[#0d0d0d]"
      data-testid="services-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          number="04"
          tag="What I Offer"
          title={<>
            <span className="text-gradient-gold">Services</span>
            <br />
            for Brands & Creators
          </>}
          kicker="From concept to color grade — a full-stack cinematic content operation you can plug into any campaign."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((svc, i) => {
            const Icon = svc.icon;
            return (
              <Reveal key={svc.title} delay={(i % 6) * 60}>
                <div
                  className="group relative overflow-hidden rounded-2xl bg-[#161616] border border-white/5 p-7 h-full raise-hover cursor-pointer"
                  data-testid={`service-card-${svc.title.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#D4AF37]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                  <div className="relative flex flex-col h-full">
                    <div className="flex items-start justify-between mb-8">
                      <div className="w-12 h-12 rounded-xl bg-[#0A0A0A] border border-[#D4AF37]/25 flex items-center justify-center group-hover:bg-[#D4AF37] transition-colors duration-500">
                        <Icon className="w-5 h-5 text-[#D4AF37] group-hover:text-black transition-colors duration-500" />
                      </div>
                      <span className="text-[10px] uppercase tracking-[0.3em] text-white/30 font-display">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="font-display text-xl text-white mb-3 group-hover:text-[#D4AF37] transition-colors">
                      {svc.title}
                    </h3>
                    <p className="text-sm text-[#B3B3B3] leading-relaxed mb-8 flex-1">
                      {svc.desc}
                    </p>
                    <div className="flex items-center justify-between pt-5 border-t border-white/5">
                      <span className="text-[10px] uppercase tracking-[0.25em] text-white/50 font-display">
                        Available Now
                      </span>
                      <ArrowUpRight className="w-4 h-4 text-white/60 group-hover:text-[#D4AF37] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
